import * as mobx from 'mobx';

export function handleScroll(pos) {
    if (pos === 'top') {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    } else {
        window.scrollTo({
            top: pos,
            behavior: "smooth"
        });
    }
}

export function smoothScrollTo(endX, endY, duration) {
    let startX = window.scrollX || window.pageXOffset,
    startY = window.scrollY || window.pageYOffset,
    distanceX = endX - startX,
    distanceY = endY - startY,
    startTime = new Date().getTime();

    // Easing function
    let easeInOutQuart = function(time, from, distance, duration) {
        if ((time /= duration / 2) < 1) return distance / 2 * time * time * time * time + from;
        return -distance / 2 * ((time -= 2) * time * time * time - 2) + from;
    };

    let timer = window.setInterval(function() {
        let time = new Date().getTime() - startTime,
        newX = easeInOutQuart(time, startX, distanceX, duration),
        newY = easeInOutQuart(time, startY, distanceY, duration);
        if (time >= duration) {
            window.clearInterval(timer);
        }
        window.scrollTo(newX, newY);
    }, 1000 / 60); // 60 fps
};

export function checkMatchingValues(val1, val2) {
    let matching = (val1 === val2 && val1 !== '' && val2 !== '') ? true : false;
    return matching;
}

export function contains(a, obj) {
    for (var i = 0; i < a.length; i++) {
        if (a[i] === obj) {
            return true;
        }
    }
    return false;
}

// export function autoSave(store, save) {
//     mobx.autorun(() => {
//         const json = JSON.stringify(mobx.toJS(store));
//         save(json);
//     });
// }

// export function save(json) {
//     this.saveToLS(json);
// }

// export function saveToLS(json) {
//     localStorage.setItem('APP_USER', json)
// }